import React from 'react';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Oblique Design System — Checkbox
 * ═══════════════════════════════════════════════════════════════════════════
 */
export const Checkbox = React.forwardRef(({
    checked,
    onCheckedChange,
    disabled = false,
    id,
    label,
    className = '',
    ...props
}, ref) => {
    return (
        <label 
            className={`inline-flex items-center gap-2 cursor-pointer select-none group ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
            htmlFor={id}
        >
            <div className="relative flex items-center justify-center">
                <input
                    type="checkbox"
                    id={id}
                    ref={ref}
                    checked={checked}
                    onChange={(e) => onCheckedChange && onCheckedChange(e.target.checked)}
                    disabled={disabled}
                    className="peer sr-only"
                    {...props}
                />
                <div className={`w-4 h-4 rounded-[4px] border border-[var(--border-strong)] bg-[var(--bg-surface)] transition-all duration-200 
                                peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--accent)] peer-focus-visible:ring-offset-1 
                                peer-checked:bg-[var(--accent)] peer-checked:border-[var(--accent)] 
                                ${!disabled && 'group-hover:border-[var(--accent)]'}`}>
                    {checked && (
                        <ObliqueIcon 
                            name="check" 
                            size={14} 
                            color="white" 
                            weight={700}
                            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" 
                        />
                    )}
                </div>
            </div>
            {label && (
                <span className="text-[13px] font-medium text-[var(--text-primary)]">
                    {label}
                </span>
            )}
        </label>
    );
});

Checkbox.displayName = 'Checkbox';
